export enum KeySpecificationType {
  RSA2048 = 'RSA2048',
  RSA3072 = 'RSA3072',
  RSA4096 = 'RSA4096',
  SECP256R1 = 'SECP256R1',
}

export const KeySpecificationList = [
  KeySpecificationType.RSA2048,
  KeySpecificationType.RSA3072,
  KeySpecificationType.RSA4096,
  KeySpecificationType.SECP256R1,
];
